export default "__VITE_PUBLIC_ASSET__36996f9a__"